import React, { ReactNode } from 'react';
import { Theme } from '../../constants/styles';
import './SectionWrapper.scss';

const SectionWrapper = ({
  section,
  children,
  theme,
  fullLength,
}: {
  section: {
    id: string;
    headerTitle: string;
    sectionTitle: string;
  };
  children?: ReactNode;
  theme: Theme;
  fullLength?: boolean;
}) => {
  return (
    <section
      id={section.id}
      className="section"
      data-theme={theme}
      data-full-length={fullLength}
    >
      <div className="section-content">
        <h2>{section.sectionTitle}</h2>
        {children ? children : <p>Placeholder Text</p>}
      </div>
    </section>
  );
};

export default SectionWrapper;
